import { shouldShowNewContent } from './formHelpers';

export const fieldsName = {
    primaryInsuredSurname: 'primaryInsuredParty-surname',
    primaryInsuredGivenName: 'primaryInsuredParty-givenName',
    primaryInsuredMiddleName: 'primaryInsuredParty-middleName',
    primaryInsuredBirthDate: 'primaryInsuredParty-birthDate',
    primaryInsuredLivingAddress: 'primaryInsuredParty-livingAddress-unstructured',
    primaryInsuredMobileNumber: 'primaryInsuredParty-mobileNumber',
    primaryInsuredEmail: 'primaryInsuredParty-email',
    primaryInsuredResident: 'primaryInsuredParty-resident',
    primaryInsuredResidentCountry: 'primaryInsuredParty-residentCountry',
    primaryInsuredIpn: 'primaryInsuredParty-ipn',
    primaryInsuredRegistrationDocumentType: 'primaryInsuredParty-registrationDocument-type',
    primaryInsuredRegistrationDocumentNumber: 'primaryInsuredParty-registrationDocument-number',
    primaryInsuredRegistrationDocumentIssueOrganization: 'primaryInsuredParty-registrationDocument-issueOrganization',
    primaryInsuredRegistrationDocumentIssueDate: 'primaryInsuredParty-registrationDocument-issueDate',
    vehicleModel: 'vehicle-model',
    vehiclePlateNumber: 'vehicle-plateNumber',
    vehicleVin: 'vehicle-vin',
    ...(shouldShowNewContent() ? {
        engineType: 'vehicle-engineType',
        vehicleEngineCapacity: 'vehicle-engineCapacity',
        vehicleBatteryCapacity: 'vehicle-batteryCapacity',
        vehicleTotalWeight: 'vehicle-totalWeight',
        vehicleOwnWeight: 'vehicle-ownWeight',
        vehicleNumberSeating: 'vehicle-numberSeating',
    } : {}),
    startDate: 'startDate',
    endDate: 'endDate',
    duration: 'duration'
}